'use stric'

const sortDirections = {
  asc: false,
  desc: true,
}

export { sortDirections }